export default function convertDateTime(createdDate: string): string {
    try {
        const dateTime = new Date(createdDate);

        return Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short', year: 'numeric' }).format(dateTime);
    } catch (err) {
        return '';
    }
}
